/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './button.module.scss';

function Button({
  children,
  type = 'primary',
  isLoading = false,
  handleClick = () => {},
  className = '',
  isDisabled = false,
}) {
  return (
    <button type="button" onClick={handleClick} className={`${styles.button} ${className} ${isDisabled ? styles.disabled : ''} ${styles[type]} ${isLoading ? styles.loading : ''}`}>
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  handleClick: PropTypes.func,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default Button;
